export const ARTISTS_SORT = [
    {
        icon: 'sort-a-z',
        sprite: 'navigation',
        code: 'name',
        direction: 'asc',
        name: 'sort.default.name'
    }, {
        icon: 'calendar',
        sprite: 'sections',
        code: 'createdAt',
        direction: 'desc',
        name: 'sort.default.created_date'
    }, {
        icon: 'sort-a-z',
        sprite: 'navigation',
        code: 'state',
        direction: 'asc',
        name: 'sort.default.state'
    }, {
        icon: 'sort-9-1',
        sprite: 'navigation',
        code: 'tracksCount',
        direction: 'asc',
        name: 'sort.default.tracks_count'
    }
]
